import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Button, Table, Row, Col } from 'reactstrap';
import { Translate, Storage } from 'react-jhipster';
import { toast } from 'react-toastify';

import { IRootState } from 'app/shared/reducers';
import { processDr } from 'app/entities/payment/payment.reducer';
import { jetcoTimestampToDateTime } from 'app/shared/util/date-utils';

export interface IPaymentResultProps extends StateProps, DispatchProps, RouteComponentProps<{ dr: string }> {}

export class PaymentResult extends React.Component<IPaymentResultProps> {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // console.log(decodeURIComponent(this.props.match.params.dr));
    if (this.props.match.params.dr) {
      const orderToken = Storage.session.get('ORDER_TOKEN');
      this.props.processDr(decodeURIComponent(this.props.match.params.dr), orderToken ? orderToken.token : '');
      this.props.history.push('/order/payment-result');
      Storage.session.remove('ORDER_TOKEN');
      Storage.session.remove('SESSION');
      Storage.session.remove('TRANSACTION');
      Storage.session.remove('PI');
      Storage.session.remove('CART');
    }
  }

  renderSuccess(dr) {
    if (dr) {
      return (
        <>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6" className="text-center bg-primary">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.paymentresult.success">付款成功!</Translate>
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6">
              <Table striped responsive>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.transactiontime">交易時間</Translate>:
                  </td>
                  <td>{jetcoTimestampToDateTime(dr.timeStamp)}</td>
                </tr>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.invoiceno">賬單號碼</Translate>:
                  </td>
                  <td>{dr.invoice}</td>
                </tr>
              </Table>
              <p className="text-center">
                <Translate contentKey="order.paymentresult.note1">
                  門票訂購已成功,閣下之郵箱將會收到確認訂單訊息,<br />請同時檢查雜件箱(Junk Mail),如24小時內仍未收到確認訂單訊息,<br />
                  歡迎電郵至 <a href="mailto:cs@patotix.com">cs@patotix.com</a> ,或致電客戶服務熱線{' '}
                  <a href="+85239080818">+852 5667 6376</a> 與我們聯絡。
                </Translate>
                <Button color="primary" href="/#/" size="xlg" className="mt-4">
                  <Translate contentKey="order.paymentresult.homebutton">返回首頁訂購其他門票</Translate>
                </Button>
              </p>
            </Col>
          </Row>
        </>
      );
    }
  }

  renderFailure(dr) {
    if (dr) {
      return (
        <>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6" className="text-center bg-danger">
              <h2 className="mt-3 mb-3 text-light">
                <Translate contentKey="order.paymentresult.failed">付款失敗</Translate>
              </h2>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4 mb-4">
            <Col md="6">
              <Table striped responsive>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.transactiontime">交易時間</Translate>:
                  </td>
                  <td>{jetcoTimestampToDateTime(dr.timeStamp)}</td>
                </tr>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.invoiceno">賬單號碼</Translate>:
                  </td>
                  <td>{dr.invoice}</td>
                </tr>
                <tr>
                  <td>
                    <Translate contentKey="order.paymentresult.referencecode">referencecode</Translate>:
                  </td>
                  <td>{dr.responseCode}</td>
                </tr>
              </Table>
              <h4 className="text-center">
                <Translate contentKey="order.paymentresult.contactus">如有查詢，請致電聯絡我們。</Translate>
              </h4>
            </Col>
          </Row>
        </>
      );
    }
  }

  render() {
    toast.dismiss();
    const dr = this.props.digitalReceipt;
    /*

        const dr = {
          'id': 9,
          'postingDate': null,
          'actualAmount': null,
          'invoice': '20181017        14',
          'drStatus': null,
          'drResponseCode': null,
          'merchantId': null,
          'ddMerchantId': null,
          'amount': 100.0,
          'currencyCode': 344,
          'locale': 'zh_tr',
          'status': 'AP',
          'responseCode': 5,
          'approvalCode': '',
          'rrNumber': null,
          'additionalResponse': '',
          'txnType': 1,
          'timeStamp': '20181017091548',
          'eci': '07',
          'cupsecSettleDate': '',
          'cupsecLastSystemTraceNum': '',
          'cardBrand': 'Visa',
          'closeBatchTime': '',
          'custIp': null,
          'shippingAddr': '',
          'shippingPhone': '',
          'shippingContactName': '',
          'shippingEmail': '',
          'transaction': {
            'id': 14,
            'transactionDateTime': '2018-10-17T17:13:28+08:00',
            'paymentDateTime': '2018-10-17T17:15:48+08:00',
            'paymentMethod': null,
            'paymentKey': null,
            'amount': 1.00,
            'creditCard': '4557071000697805',
            'status': 'REJECTED',
            'invoiceNo': '20181017        14',
            'tickets': null,
            'user': {
              'id': 3,
              'login': 'admin',
              'firstName': 'Administrator',
              'lastName': 'Administrator',
              'email': 'admin@localhost',
              'activated': true,
              'langKey': 'en',
              'imageUrl': '',
              'resetDate': null
            }
          }
        };
    */

    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="12" className="text-center">
              <h1 className="mt-3 mb-3">
                <Translate contentKey="order.paymentresult.status">交易狀況</Translate>
              </h1>
            </Col>
          </Row>
          {dr && dr.status === 'AP' ? this.renderSuccess(dr) : this.renderFailure(dr)}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  digitalReceipt: storeState.payment.digitalReceipt,
  currentLocale: storeState.locale.currentLocale
});

const mapDispatchToProps = { processDr };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResult);
